import React, { useDebugValue, useEffect } from 'react'
import BreadCrumb from '../../Components/Common/BreadCrumb'
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import { createSelector } from 'reselect';
import { ToastContainer } from 'react-toastify';
import checkPermission from '../../Components/Hooks/PermissionHook';
import { push } from 'redux-first-history';
import { setBreadcrumb } from '../../slices/auth/menu/reducer';
import Preloader from '../../Components/Common/Preloader';

function Publish() {
  const dispatch = useDispatch();
  const params = useParams();
  document.title = "Publish | Adcropper";
  const selectCurrentCampaign = createSelector(state => state, state => ({
    publishLoader: state.Publish.publishLoader,
    currentCampaign: state.Campaign.currentCampaign,
    brandPath: state.MenuData.brandPath,
    marketPath: state.MenuData.marketPath,
    title: state.MenuData.title,
  }));
  const { publishLoader, currentCampaign, brandPath, marketPath, title } = useSelector(selectCurrentCampaign);

  useEffect(() => {
    dispatch(setBreadcrumb({pageTitle: 'Publish', title: [{name: 'Publish', src:window.location.href}]}));
  }, []);

  useEffect(() => {
    if (!params.hasOwnProperty('campaignId')) {
      let navigateUrl =`/${params.client}/${params.brand}`; 
      if (params.hasOwnProperty('market')) {
        navigateUrl += `/${params.market}`;
      }
      navigateUrl += '/campaigns/filter/all';
      dispatch(push(navigateUrl));
    }
  }, [params]);

  if (checkPermission((marketPath ? "markets" : "brands"), (marketPath ? marketPath : brandPath), "cPublish")) {
    return (
      <React.Fragment>
        {publishLoader ? <Preloader /> : null}
        {/* <BreadCrumb title={currentCampaign ? currentCampaign.name : 'Pages'} pageTitle={'Publish'} /> */}
        <Outlet />
      </React.Fragment>
    )
  } else {
    return (
      <Navigate to={"/out-of-permission"} />
    )
  }

}

export default Publish;